import styled from 'styled-components'

import { spaces } from '@/config/global-parameters'

const SubTitle = styled.div`
  font-weight: 300;
  font-size: 13px;
  text-align: center;
  max-width: ${spaces.tabletBreakpoint};
`

export default SubTitle
